import { errorLink } from "Apollo/Links/ErrorLink";
import { retryLink } from "Apollo/Links/RetryLink";
import { httpLink } from "Apollo/Links/HttpLink";
import { ApolloClient, from } from "@apollo/client";
import cache from "Apollo/cache";

const link = from([retryLink, errorLink, httpLink]);

const client = new ApolloClient({
    cache: cache,
    link: link,
});

export default client;
